module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    key: _vm.$route.path,
    attrs: {
      "edit-mode": _vm.editMode
    },
    on: {
      "next": function($event) {
        _vm.next()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e00a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/Checkout.vue
// module id = 600
// module chunks = 66